import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

function ProjectModal({ project, onClose }) {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
        <motion.div
          initial={{ opacity: 0, scale: 0.92, y: 16 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.92, y: 16 }}
          transition={{ type: "spring", duration: 0.4 }}
          className="relative bg-gray-900 border border-gray-700/50 rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-end p-4 pb-0">
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white bg-gray-800 hover:bg-gray-700 p-2 rounded-lg transition-colors"
              aria-label="Close modal"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <div className="p-6 pt-2 flex flex-col lg:flex-row gap-6">
            <div className="lg:w-1/2">
              <img
                src={project.image}
                alt={project.title}
                className="w-full rounded-xl object-cover"
              />
              <a href={project.link} target="_blank" rel="noopener noreferrer" className="block mt-4">
                <button className="w-full flex items-center justify-center gap-2 text-white bg-emerald-600 hover:bg-emerald-500 py-2.5 rounded-lg text-sm font-medium transition-colors">
                  View Live
                  <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
                </button>
              </a>
            </div>
            <div className="lg:w-1/2">
              <h3 className="text-emerald-400 text-xl font-bold mb-3">{project.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">{project.description}</p>
              <div className="flex flex-wrap gap-2">
                {project.Stack.map((stack, i) => (
                  <span
                    key={i}
                    className="bg-gray-800 text-gray-300 border border-gray-700 rounded-full px-3 py-1 text-xs"
                  >
                    {stack}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

export default ProjectModal;
